import React from "react";
import { useLocation, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { getBreadcrumbs } from "./breadcrumbUtils";
import "./breadcrumbStyles.css";

const Breadcrumbs = () => {
  const location = useLocation();
  const path = location.pathname;

  if (path === "/") return null;

  const crumbs = getBreadcrumbs(path);

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://groomieroomie.com/"
      },
      ...crumbs.map((crumb, i) => ({
        "@type": "ListItem",
        position: i + 2,
        name: crumb.label,
        item: `https://groomieroomie.com${crumb.url}`
      }))
    ]
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>

      <nav aria-label="Breadcrumb" className="crumb-wrapper">
        <ol className="crumb-list">
          <li>
            <Link to="/" className="crumb-pill">Home</Link>
          </li>

          {crumbs.map((crumb, index) => (
            <li key={index}>
              <Link
                to={crumb.url}
                className={`crumb-pill ${index === crumbs.length - 1 ? "active" : ""}`}
                aria-current={index === crumbs.length - 1 ? "page" : undefined}
              >
                {crumb.label}
              </Link>
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumbs;
